// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + ({"1124": "pdf","3570": "math~2","4498": "ckeditor~1","9999": "excalidraw~3",}[chunkId] || chunkId) + "." + {"1124": "ba84c3bf","1528": "560c4800","3570": "e668c082","4498": "7984043a","9999": "5c77096e",}[chunkId] + ".css"
}